if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 768px)');
        if (!this.elements.thumbnails) return;

        this.initializeSliderControls();

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
      }

      initializeSliderControls() {
        const prevButton = this.querySelector('.slider-button--prev');
        const nextButton = this.querySelector('.slider-button--next');

        if (prevButton && nextButton) {
          prevButton.addEventListener('click', () => this.handleSlideChange('prev'));
          nextButton.addEventListener('click', () => this.handleSlideChange('next'));

          this.updateSliderButtonStates();
        }
      }

      handleSlideChange(direction) {
        const slides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
        const currentSlide = this.elements.viewer.querySelector('.is-active');
        const currentIndex = slides.indexOf(currentSlide);

        let newIndex;
        if (direction === 'next') {
          newIndex = (currentIndex + 1) % slides.length;
        } else {
          newIndex = (currentIndex - 1 + slides.length) % slides.length;
        }

        const nextSlide = slides[newIndex];
        if (nextSlide && nextSlide.dataset.mediaId) {
          this.setActiveMedia(nextSlide.dataset.mediaId, false);
        }
      }

      updateSliderButtonStates() {
        const slides = this.elements.viewer.querySelectorAll('.product__media-item');
        const prevButton = this.querySelector('.slider-button--prev');
        const nextButton = this.querySelector('.slider-button--next');

        if (slides.length <= 1) {
          prevButton?.setAttribute('disabled', 'disabled');
          nextButton?.setAttribute('disabled', 'disabled');
        } else {
          const currentSlide = this.elements.viewer.querySelector('.is-active');
          const currentIndex = Array.from(slides).indexOf(currentSlide);

          prevButton?.removeAttribute('disabled');
          nextButton?.removeAttribute('disabled');

          if (currentIndex === 0) {
            prevButton?.setAttribute('disabled', 'disabled');
          }
          if (currentIndex === slides.length - 1) {
            nextButton?.setAttribute('disabled', 'disabled');
          }
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.updateSliderButtonStates();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        const slides = this.elements.viewer.querySelectorAll('.product__media-item');
        const currentIndex = Array.from(slides).indexOf(activeMedia);
        const counter = this.querySelector('.slider-counter--current');
        if (counter) {
          counter.textContent = (currentIndex + 1).toString();
        }

        if (prepend) {
          const insertAfterLeadVideos = (el) => {
            if (!el) return;
            const list = el.parentElement;
            const leads = list.querySelectorAll(':scope > [data-gallery-lead]');
            const anchor = leads.length ? leads[leads.length - 1].nextElementSibling : list.firstElementChild;
            if (el !== anchor) list.insertBefore(el, anchor);
          };
          insertAfterLeadVideos(activeMedia);
          if (this.elements.thumbnails) {
            insertAfterLeadVideos(this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`));
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);
        this.updateSliderButtonStates();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        // on screens smaller than 750px, scroll horizontal to the selected media
        // when selecting an off-screen image's thumbnail
        // and prevent scroll to top of page
        if (!this.mql?.matches && this.elements?.viewer?.slider) {
          this.elements?.viewer?.slider?.scrollTo({
            left: activeMedia?.offsetLeft,
            behavior: 'smooth',
          });
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img, .hls-poster-thumbnail');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
